import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { compose } from 'redux'
import { reduxForm, Field } from 'redux-form'

import { SeatTradeSearchResultsFormName } from '../../config/forms'

import getLabels from '../../utils/getLabels'
import componentIsFetching from '../../utils/components/componentIsFetching'
import { isSeatCountValid } from '../../utils/validation/seatTrade'

import SeatTradeMenu from '../../containers/SeatTrade/SeatTradeMenu'

import Table from '../Table'
import Notifications from '../Notifications'
import SeatTradeModal from '../SeatTradeModal'
import DisplayCollection from '../DisplayCollection'
import FlightPassengerRenderField from '../FlightPassengerRenderField'

const seatTradeHeaders = [
  {
    name: 'flightNumber',
    content: getLabels('flight_number'),
    width: '15%',
  },
  {
    name: 'dayOfWeek',
    content: getLabels('day'),
    width: '15%',
  },
  {
    name: 'departureDate',
    content: getLabels('departure_date'),
    width: '20%',
  },
  {
    name: 'departureTime',
    content: getLabels('time'),
    width: '15%',
  },
  {
    name: 'availableSeats',
    content: getLabels('available_seats'),
    width: '35%',
  },
]

const SeatTradeSearchResults = ({
  classes,
  searchResults,
  departureAirport,
  arrivalAirport,
  setContextMenu,
  confirmTrade,
  context,
  onSeatTrade,
  seatsAreBeingTraded,
  errors,
  notifications,
  resetNotifications,
  seatTradeNotifications,
}) => {
  const tableData = {
    columns: seatTradeHeaders,
    extraColumnCell: (
      <React.Fragment>
        <Notifications
          type="success"
          notifications={notifications}
          clearNotifications={resetNotifications}
        />

        {errors.length > 0 && (
          <div className={classes.rowError} key={`seat-trade-error`}>
            {getLabels('seat_trade_failed')}
          </div>
        )}
      </React.Fragment>
    ),
    rows:
      searchResults.length &&
      searchResults.map(
        ({
          details: { flightNumber, departureDay, departureDate, departureTime },
          flightId,
          availableSeatCount,
        }) => {
          return {
            id: flightId,
            isError:
              errors.find(
                ({ data: { flightId: errorFlightId } }) =>
                  errorFlightId === flightId
              ) !== undefined,
            isSuccess:
              seatTradeNotifications.find(
                ({ data = {} }) => data.flightId === flightId
              ) !== undefined,
            flightNumber: <div className={classes.cel}>{flightNumber}</div>,
            dayOfWeek: <div className={classes.cel}>{departureDay}</div>,
            departureDate: <div className={classes.cel}>{departureDate}</div>,
            departureTime: <div className={classes.cel}>{departureTime}</div>,
            availableSeats: (
              <div className={classNames(classes.cel, classes.cellMerger)}>
                <Field
                  name={flightId}
                  component={FlightPassengerRenderField}
                  type="number"
                  inputClassName={classes.field}
                  max={availableSeatCount}
                  validate={isSeatCountValid}
                />
                <span
                  data-element={`${flightId}-avaible-seat-count`}
                >{`\u00A0/ ${availableSeatCount}`}</span>
              </div>
            ),
          }
        }
      ),
  }

  return (
    <React.Fragment>
      <div className={classes.wrapper}>
        <header className={classes.header}>
          <h2
            className={classes.title}
          >{`${departureAirport.name} - ${arrivalAirport.name}`}</h2>
        </header>

        <DisplayCollection
          hasResults={searchResults.length > 0}
          noResultsMessage={
            <p className={classes.row}>{getLabels('no_results_found')}</p>
          }
        >
          <Table
            columns={tableData.columns}
            rows={tableData.rows}
            extraColumnCell={tableData.extraColumnCell}
          />
        </DisplayCollection>
      </div>

      <SeatTradeModal isOpen={confirmTrade} setContextMenu={setContextMenu} />

      <SeatTradeMenu
        setContextMenu={setContextMenu}
        context={context}
        onSeatTrade={onSeatTrade}
        seatsAreBeingTraded={seatsAreBeingTraded}
      />
    </React.Fragment>
  )
}

SeatTradeSearchResults.propTypes = {
  classes: PropTypes.shape({
    buttonDelete: PropTypes.string,
    buttonEdit: PropTypes.string,
  }),
  searchResults: PropTypes.array,
  hidden: PropTypes.bool,
  departureAirport: PropTypes.shape({
    name: PropTypes.string,
  }),
  arrivalAirport: PropTypes.shape({
    name: PropTypes.string,
  }),
  confirmTrade: PropTypes.bool,
}

SeatTradeSearchResults.defaultProps = {
  hidden: false,
  departureAirport: {},
  arrivalAirport: {},
  searchResults: [],
}

export default compose(
  reduxForm({
    form: SeatTradeSearchResultsFormName,
  }),
  componentIsFetching
)(SeatTradeSearchResults)
